export const toCurrent = (price: number) => {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(price);
};

export const toFixed = (value: number, places: number) => {
  return Number(value.toFixed(places));
};
